// extracted by mini-css-extract-plugin
export var actions = "_cg-g";
export var benefitCard = "_cg-b";
export var benefitIcon = "_cg-d";
export var benefitLabel = "_cg-f";
export var benefits = "_cg-a";
export var benefitsSection = "_cg-8";
export var bodyText = "_cg-7";
export var closeButton = "_cg-2";
export var content = "_cg-3";
export var eyebrow = "_cg-4";
export var heading = "_cg-5";
export var image = "_cg-i";
export var imagePanel = "_cg-h";
export var modal = "_cg-0";
export var offerCard = "_cg-c";
export var offerIcon = "_cg-e";
export var sectionLabel = "_cg-9";
export var shell = "_cg-1";
export var title = "_cg-6";